/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAmpUser = /* GraphQL */ `
  mutation CreateAmpUser(
    $input: CreateAmpUserInput!
    $condition: ModelAmpUserConditionInput
  ) {
    createAmpUser(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      email
      owner
      anonymizedOwner
      username
      anonymizedUsername
      userStatus
      ampUserTypes
      lastLoginDateTimeUTC
      lastLoginDateTimeLocal
      lastLoginTimestampUTC
      lastLoginTimestampLocal
      name
      phone
      phoneE1164
      alternatePhone
      alternatePhoneE1164
      address
      city
      state
      zip
      country
      streetAddress
      alternateContactName
      alternateContactPhone
      alternateContactPhoneE164
      lastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      intakeFormCompleted
      routerPath
      sharedRouterPath
      isEdited
      lastEditedAtDateTimeUTC
      lastEditedAtDateTimeLocal
      lastEditedAtTimestampUTC
      lastEditedAtTimestampLocal
      isDeleted
      isArchived
      isAnonymized
      waitlistUserIdField
      anonymizedWaitlistUserIdField
      createdAt
      updatedAt
    }
  }
`;
export const updateAmpUser = /* GraphQL */ `
  mutation UpdateAmpUser(
    $input: UpdateAmpUserInput!
    $condition: ModelAmpUserConditionInput
  ) {
    updateAmpUser(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      email
      owner
      anonymizedOwner
      username
      anonymizedUsername
      userStatus
      ampUserTypes
      lastLoginDateTimeUTC
      lastLoginDateTimeLocal
      lastLoginTimestampUTC
      lastLoginTimestampLocal
      name
      phone
      phoneE1164
      alternatePhone
      alternatePhoneE1164
      address
      city
      state
      zip
      country
      streetAddress
      alternateContactName
      alternateContactPhone
      alternateContactPhoneE164
      lastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      intakeFormCompleted
      routerPath
      sharedRouterPath
      isEdited
      lastEditedAtDateTimeUTC
      lastEditedAtDateTimeLocal
      lastEditedAtTimestampUTC
      lastEditedAtTimestampLocal
      isDeleted
      isArchived
      isAnonymized
      waitlistUserIdField
      anonymizedWaitlistUserIdField
      createdAt
      updatedAt
    }
  }
`;
export const deleteAmpUser = /* GraphQL */ `
  mutation DeleteAmpUser(
    $input: DeleteAmpUserInput!
    $condition: ModelAmpUserConditionInput
  ) {
    deleteAmpUser(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      email
      owner
      anonymizedOwner
      username
      anonymizedUsername
      userStatus
      ampUserTypes
      lastLoginDateTimeUTC
      lastLoginDateTimeLocal
      lastLoginTimestampUTC
      lastLoginTimestampLocal
      name
      phone
      phoneE1164
      alternatePhone
      alternatePhoneE1164
      address
      city
      state
      zip
      country
      streetAddress
      alternateContactName
      alternateContactPhone
      alternateContactPhoneE164
      lastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      intakeFormCompleted
      routerPath
      sharedRouterPath
      isEdited
      lastEditedAtDateTimeUTC
      lastEditedAtDateTimeLocal
      lastEditedAtTimestampUTC
      lastEditedAtTimestampLocal
      isDeleted
      isArchived
      isAnonymized
      waitlistUserIdField
      anonymizedWaitlistUserIdField
      createdAt
      updatedAt
    }
  }
`;
export const createAmpUserSharedProfile = /* GraphQL */ `
  mutation CreateAmpUserSharedProfile(
    $input: CreateAmpUserSharedProfileInput!
    $condition: ModelAmpUserSharedProfileConditionInput
  ) {
    createAmpUserSharedProfile(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      owner
      anonymizedOwner
      isEdited
      isSharedPublic
      isSharedPrivate
      sharedPrivateAmpUserIdFields
      sharedProfileName
      sharedProfileEmail
      sharedProfilePhone
      sharedProfilePhoneE164
      sharedProfileAlternatePhone
      sharedProfileAlternatePhoneE164
      sharedProfileAddress
      sharedProfileCity
      sharedProfileState
      sharedProfileZip
      sharedProfileCountry
      sharedProfileStreetAddress
      sharedProfileAlternateContactName
      sharedProfileAlternateContactPhone
      sharedProfileAlternateContactPhoneE164
      sharedProfileDescription
      sharedProfileImage
      sharedProfileImageEtag
      sharedProfileImageKey
      sharedProfileImageLastEditedDateTimeUTC
      sharedProfileImageLastEditedTimestampUTC
      sharedProfileImageLastEditedBy
      sharedProfileSharedPublicAttributes
      sharedProfileSharedPrivateAttributes
      sharedProfileMetadataObj
      sharedProfileRouterPath
      sharedProfilePublicRouterPath
      sharedProfilePrivateRouterPath
      sharedProfileLastEditedDateTimeUTC
      sharedProfileLastEditedTimestampUTC
      sharedProfileLastEditedBy
      sharedProfileLastEditedById
      isArchived
      isAnonymized
      isDeleted
      ampUserIdField
      anonymizedAmpUserIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const updateAmpUserSharedProfile = /* GraphQL */ `
  mutation UpdateAmpUserSharedProfile(
    $input: UpdateAmpUserSharedProfileInput!
    $condition: ModelAmpUserSharedProfileConditionInput
  ) {
    updateAmpUserSharedProfile(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      owner
      anonymizedOwner
      isEdited
      isSharedPublic
      isSharedPrivate
      sharedPrivateAmpUserIdFields
      sharedProfileName
      sharedProfileEmail
      sharedProfilePhone
      sharedProfilePhoneE164
      sharedProfileAlternatePhone
      sharedProfileAlternatePhoneE164
      sharedProfileAddress
      sharedProfileCity
      sharedProfileState
      sharedProfileZip
      sharedProfileCountry
      sharedProfileStreetAddress
      sharedProfileAlternateContactName
      sharedProfileAlternateContactPhone
      sharedProfileAlternateContactPhoneE164
      sharedProfileDescription
      sharedProfileImage
      sharedProfileImageEtag
      sharedProfileImageKey
      sharedProfileImageLastEditedDateTimeUTC
      sharedProfileImageLastEditedTimestampUTC
      sharedProfileImageLastEditedBy
      sharedProfileSharedPublicAttributes
      sharedProfileSharedPrivateAttributes
      sharedProfileMetadataObj
      sharedProfileRouterPath
      sharedProfilePublicRouterPath
      sharedProfilePrivateRouterPath
      sharedProfileLastEditedDateTimeUTC
      sharedProfileLastEditedTimestampUTC
      sharedProfileLastEditedBy
      sharedProfileLastEditedById
      isArchived
      isAnonymized
      isDeleted
      ampUserIdField
      anonymizedAmpUserIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const deleteAmpUserSharedProfile = /* GraphQL */ `
  mutation DeleteAmpUserSharedProfile(
    $input: DeleteAmpUserSharedProfileInput!
    $condition: ModelAmpUserSharedProfileConditionInput
  ) {
    deleteAmpUserSharedProfile(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      owner
      anonymizedOwner
      isEdited
      isSharedPublic
      isSharedPrivate
      sharedPrivateAmpUserIdFields
      sharedProfileName
      sharedProfileEmail
      sharedProfilePhone
      sharedProfilePhoneE164
      sharedProfileAlternatePhone
      sharedProfileAlternatePhoneE164
      sharedProfileAddress
      sharedProfileCity
      sharedProfileState
      sharedProfileZip
      sharedProfileCountry
      sharedProfileStreetAddress
      sharedProfileAlternateContactName
      sharedProfileAlternateContactPhone
      sharedProfileAlternateContactPhoneE164
      sharedProfileDescription
      sharedProfileImage
      sharedProfileImageEtag
      sharedProfileImageKey
      sharedProfileImageLastEditedDateTimeUTC
      sharedProfileImageLastEditedTimestampUTC
      sharedProfileImageLastEditedBy
      sharedProfileSharedPublicAttributes
      sharedProfileSharedPrivateAttributes
      sharedProfileMetadataObj
      sharedProfileRouterPath
      sharedProfilePublicRouterPath
      sharedProfilePrivateRouterPath
      sharedProfileLastEditedDateTimeUTC
      sharedProfileLastEditedTimestampUTC
      sharedProfileLastEditedBy
      sharedProfileLastEditedById
      isArchived
      isAnonymized
      isDeleted
      ampUserIdField
      anonymizedAmpUserIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const createAmpUserSubscriber = /* GraphQL */ `
  mutation CreateAmpUserSubscriber(
    $input: CreateAmpUserSubscriberInput!
    $condition: ModelAmpUserSubscriberConditionInput
  ) {
    createAmpUserSubscriber(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      appAccountToken
      currentSubBeginDateTimeUTC
      currentSubBeginDateTimeLocal
      currentSubBeginTimestampUTC
      currentSubBeginTimestampLocal
      currentSubBeginDateUTC
      currentSubBeginDateLocal
      currentSubEndDateTimeUTC
      currentSubEndDateTimeLocal
      currentSubEndTimestampUTC
      currentSubEndTimestampLocal
      currentSubEndDateUTC
      currentSubEndDateLocal
      currentSubUserStatus
      currentSubUserSubStatus
      currentUserSubImagePeriodQuotaIdField
      currentUserSubImagePeriodAnimalQuotaIdField
      subIsActive
      ampUserLastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      isEdited
      lastEditedDateTimeUTC
      lastEditedDateTimeLocal
      lastEditedTimestampUTC
      lastEditedTimestampLocal
      isArchived
      isAnonymized
      isDeleted
      owner
      anonymizedOwner
      ampUserIdField
      anonymizedAmpUserIdField
      vaultOwnerIdField
      anonymizedVaultOwnerIdField
      currentUserSubIdField
      lastUserSubIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const updateAmpUserSubscriber = /* GraphQL */ `
  mutation UpdateAmpUserSubscriber(
    $input: UpdateAmpUserSubscriberInput!
    $condition: ModelAmpUserSubscriberConditionInput
  ) {
    updateAmpUserSubscriber(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      appAccountToken
      currentSubBeginDateTimeUTC
      currentSubBeginDateTimeLocal
      currentSubBeginTimestampUTC
      currentSubBeginTimestampLocal
      currentSubBeginDateUTC
      currentSubBeginDateLocal
      currentSubEndDateTimeUTC
      currentSubEndDateTimeLocal
      currentSubEndTimestampUTC
      currentSubEndTimestampLocal
      currentSubEndDateUTC
      currentSubEndDateLocal
      currentSubUserStatus
      currentSubUserSubStatus
      currentUserSubImagePeriodQuotaIdField
      currentUserSubImagePeriodAnimalQuotaIdField
      subIsActive
      ampUserLastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      isEdited
      lastEditedDateTimeUTC
      lastEditedDateTimeLocal
      lastEditedTimestampUTC
      lastEditedTimestampLocal
      isArchived
      isAnonymized
      isDeleted
      owner
      anonymizedOwner
      ampUserIdField
      anonymizedAmpUserIdField
      vaultOwnerIdField
      anonymizedVaultOwnerIdField
      currentUserSubIdField
      lastUserSubIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const deleteAmpUserSubscriber = /* GraphQL */ `
  mutation DeleteAmpUserSubscriber(
    $input: DeleteAmpUserSubscriberInput!
    $condition: ModelAmpUserSubscriberConditionInput
  ) {
    deleteAmpUserSubscriber(input: $input, condition: $condition) {
      id
      internalTrackingId
      anonymizedId
      appAccountToken
      currentSubBeginDateTimeUTC
      currentSubBeginDateTimeLocal
      currentSubBeginTimestampUTC
      currentSubBeginTimestampLocal
      currentSubBeginDateUTC
      currentSubBeginDateLocal
      currentSubEndDateTimeUTC
      currentSubEndDateTimeLocal
      currentSubEndTimestampUTC
      currentSubEndTimestampLocal
      currentSubEndDateUTC
      currentSubEndDateLocal
      currentSubUserStatus
      currentSubUserSubStatus
      currentUserSubImagePeriodQuotaIdField
      currentUserSubImagePeriodAnimalQuotaIdField
      subIsActive
      ampUserLastPaymentHash
      lastSubSuccessPageSyncTimestampUTC
      lastSubSuccessPageSyncTimestampLocal
      isEdited
      lastEditedDateTimeUTC
      lastEditedDateTimeLocal
      lastEditedTimestampUTC
      lastEditedTimestampLocal
      isArchived
      isAnonymized
      isDeleted
      owner
      anonymizedOwner
      ampUserIdField
      anonymizedAmpUserIdField
      vaultOwnerIdField
      anonymizedVaultOwnerIdField
      currentUserSubIdField
      lastUserSubIdField
      ampuserID
      createdAt
      updatedAt
    }
  }
`;
export const createContactSubmission = /* GraphQL */ `
  mutation CreateContactSubmission(
    $input: CreateContactSubmissionInput!
    $condition: ModelContactSubmissionConditionInput
  ) {
    createContactSubmission(input: $input, condition: $condition) {
      id
      contactSubmissionType
      email
      subject
      contactSubmissionSubject
      message
      contactSubmissionMessage
      contactSubmissionStatus
      owner
      createdAt
      updatedAt
    }
  }
`;
export const updateContactSubmission = /* GraphQL */ `
  mutation UpdateContactSubmission(
    $input: UpdateContactSubmissionInput!
    $condition: ModelContactSubmissionConditionInput
  ) {
    updateContactSubmission(input: $input, condition: $condition) {
      id
      contactSubmissionType
      email
      subject
      contactSubmissionSubject
      message
      contactSubmissionMessage
      contactSubmissionStatus
      owner
      createdAt
      updatedAt
    }
  }
`;
export const deleteContactSubmission = /* GraphQL */ `
  mutation DeleteContactSubmission(
    $input: DeleteContactSubmissionInput!
    $condition: ModelContactSubmissionConditionInput
  ) {
    deleteContactSubmission(input: $input, condition: $condition) {
      id
      contactSubmissionType
      email
      subject
      contactSubmissionSubject
      message
      contactSubmissionMessage
      contactSubmissionStatus
      owner
      createdAt
      updatedAt
    }
  }
`;
